<template>
  <div
    @click="closeWorkTimeModal"
    class="py-3 md-pd flex items-center w-full h-full justify-center worktime__modal__container"
  >
    <section
      @click.stop
      class="w-11/12 md:w-9/12 lg:w-1/2 xl:w-1/3 p-4 relative"
    >
      <div
        @click="closeWorkTimeModal"
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>

      <vue-perfect-scrollbar class="overflow-container">
        <vx-card>
          <div class="flex items-center justify-between">
            <h4 class="text-2xl font-bold text-left heading-black">
              Offline learning rewards
            </h4>
            <div class="relative">
              <img
                class="absolute coin w-8 h-8"
                src="@/assets/images/icons/tokens/xp.svg"
                alt="xp"
              />
              <h4
                class="ml-50 text-xl font-bold text-left heading-black gradient-bg px-5 py-1 rounded-full"
              >
                2.5/hr
              </h4>
            </div>
          </div>
          <div
            ref="progressBar"
            id="progressBar"
            class="w-full p-2 relative flex items-center justify-center overflow-hidden z-10"
          >
            <div
              class="bar absolute left-0"
              :style="{ width: progressBarWidth + '%' }"
            ></div>
            <p class="font-semibold text-xl text-white z-20">
              Time left {{ timeLeft ? timeLeft : "00:00:00" }}
            </p>
          </div>

          <!-- <vx-card class="my-6 card-shadow">
            <div class="flex items-center justify-between">
              <h4 class="text-xl font-bold text-left heading-black">Rewards</h4>
              <div class="relative">
                <img
                  class="absolute coin w-8 h-8"
                  src="@/assets/images/icons/tokens/xp.svg"
                  alt="xp"
                />
                <h4
                  class="ml-50 text-xl font-bold text-left heading-black gradient-bg px-5 py-1 rounded-full"
                >
                  2.5/hr
                </h4>
              </div>
            </div>
            <div class="my-6 flex items-center justify-start">
              <div
                class="token-box w-16 h-16 relative flex items-center justify-center p-8"
              >
                <img
                  class="w-8 h-8"
                  src="@/assets/images/icons/tokens/xp.svg"
                  alt=""
                />
                <h6 class="absolute text-xl">100</h6>
              </div>

              <div
                class="token-box w-16 h-16 relative flex items-center justify-center p-8 mx-2"
              >
                <img
                  class="w-8 h-8"
                  src="@/assets/images/icons/tokens/gold-coin.svg"
                  alt=""
                />
                <h6 class="absolute text-xl">10</h6>
              </div>
            </div>
            <div mt-4>
              <h4 class="text-xl font-bold text-left heading-black">
                Notice :
              </h4>
              <h4 class="text-xl text-left heading-gray my-1">
                Use your key for the next Journey
              </h4>
              <h4 class="text-lg text-left heading-red">
                {Can be the next Journey or board assignment}
              </h4>
            </div> 
          </vx-card> -->

          <div
            class="btn-claim text-2xl font-semibold rounded-lg py-2 px-4 cursor-pointer mt-4"
            :class="timeLeft ? 'opacity-50 pointer-events-none' : ''"
            @click="claimDailyReward"
          >
            Claim
          </div>

          <!-- validation notification -->
          <!-- skeleton -->
          <vs-row v-if="activitySkeleton" class="pb-3">
            <vs-row
              v-for="i in 5"
              :key="i"
              class="p-8 skeleton rounded-lg my-2"
            />
          </vs-row>

          <div class="mt-8" v-if="!activitySkeleton && weeklyItems.length > 0">
            <h4 class="text-xl font-bold text-left heading-black">
              New items in activity queue
            </h4>
            <h5 class="text-left heading-gray my-1">
              Mark the ones you have finished doing to enable validation.
            </h5>
          </div>

          <div v-if="!activitySkeleton && weeklyItems.length > 0">
            <div
              v-for="(item, index) in weeklyItems"
              :key="index"
              class="flex items-center justify-between w-full border px-4 py-4"
            >
              <div class="flex w-4/5">
                <div class="w-32 h-24 overflow-hidden rounded-lg">
                  <img
                    class="w-full h-full object-cover"
                    :src="item.imageUrl"
                    :alt="item.title"
                    @error="randomFeedImage"
                  />
                </div>
                <div class="w-full md:w-56 flex flex-col mx-4 md:mx-2">
                  <h5 class="text-left">{{ item.title }}</h5>
                </div>
              </div>

              <div
                @click="setDevelopmentStage(index, item, 'done')"
                class="text-xl rounded-full py-75 px-3 cursor-pointer"
                :class="item.status === 'done' ? 'btn-done' : 'btn-done-2'"
              >
                <vs-icon
                  icon="icon-check"
                  icon-pack="feather"
                  size="1.5rem"
                  :color="item.status === 'done' ? '#fff' : ' #25cc9a'"
                ></vs-icon>
              </div>
            </div>
          </div>

          <h5
            v-if="!activitySkeleton && weeklyItems.length === 0"
            class="text-left heading-gray my-1"
          >
            Add items to your queue from Development Charter.
          </h5>
        </vx-card>
      </vue-perfect-scrollbar>
    </section>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "WorkTimeModal",
  data() {
    return {
      activitySkeleton: false,
      startTime: "",
      resetTime: "",
      duration: 6 * 60 * 60, // 6 hours in seconds
      isTimerReset: false,
    };
  },
  props: {
    weeklyItems: {
      required: true,
      type: Array,
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    timeLeft() {
      const currentTime = new Date();
      const elapsedTime = (currentTime - this.startTime) / 1000; // Elapsed time in seconds
      const remainingTime = Math.max(0, this.duration - elapsedTime);
      if (remainingTime <= 0) {
        return "";
      }
      const hours = Math.floor(remainingTime / 3600);
      const minutes = Math.floor((remainingTime % 3600) / 60);
      const seconds = Math.floor(remainingTime % 60);
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(seconds).padStart(2, "0")}`;
    },
    progressBarWidth() {
      const currentTime = new Date();
      const elapsedTime = (currentTime - this.startTime) / 1000; // Elapsed time in seconds
      const remainingTime = Math.max(0, this.duration - elapsedTime);
      const width = (remainingTime / this.duration) * 100;
      return width < 0 ? 0 : width;
    },
  },
  mounted() {
    this.getTimer();
  },
  methods: {
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    setDevelopmentStage(index, i, status) {
      const payload = {
        type: i.type,
        getboardedId: this.userData._id,
        itemId: i.itemId,
        status: status,
      };

      this.$store
        .dispatch("feed/updateCourseStatus", payload)
        .then((res) => {
          if (status === "done") {
            this.$vs.notify({
              color: "success",
              text: "This item is marked 'done'. Learning is it's own reward...yet, we are working on topping it up with validations and rewards. This transaction may have an applicable claim later.",
              time: 5000,
            });
          }
          this.weeklyItems[index].status = status;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    closeWorkTimeModal() {
      sessionStorage.setItem("workTimeModal", false);
      this.$store.commit("modals/OPEN_WORK_TIME_POPUP", false);
    },
    activateTimer() {
      this.$store
        .dispatch("users/activateTimer", {
          gtbrddUserId: this.userData._id,
          gtbrddOrganizationId: "60b0ee8721858009ea226136",
        })
        .then((res) => {
          if (res && res.data && res.data._id) {
            this.isTimerReset = true;
            this.resetTime = new Date().toISOString();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTimer() {
      this.$store
        .dispatch("users/getTimer", {
          userId: this.userData._id,
          orgId: "60b0ee8721858009ea226136",
        })
        .then((res) => {
          if (res && res.data && res.data.activated_at) {
            this.previousInterval = setInterval(() => {
              if (this.isTimerReset) {
                res.data.activated_at = this.resetTime;
              }
              this.startTime = new Date(res.data.activated_at);
            }, 1000);
          } else {
            this.activateTimer();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    claimDailyReward() {
      this.$store
        .dispatch("users/claimTimer", {
          gtbrddUserId: this.userData._id,
          gtbrddOrganizationId: "60b0ee8721858009ea226136",
        })
        .then((res) => {
          if (res && res.data && res.data._id) {
            this.activateTimer();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: 0;
  right: 0;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}

#progressBar {
  margin: 10px auto;
  height: 2rem;
  background-color: #b8c3c3;
  border-radius: 0.75rem;
}
#progressBar div {
  height: 100%;
  text-align: center;
  width: 0;
  background-color: #25cc9a;
  box-sizing: border-box;
  z-index: -1;
}

.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.worktime__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    .vs-tooltip {
      z-index: 5200000;
    }
    .heading {
      &-black {
        color: #000000 !important;
      }
      &-gray {
        color: #948f8f !important;
      }
      &-red {
        color: #ff6584 !important;
      }
    }
    .gradient-bg {
      background: linear-gradient(270deg, #e0ecff 0%, #ffeab4 100%);
    }
    .coin {
      left: -0.875rem;
    }
    .overflow-container {
      max-height: 35em;
      overflow-y: scroll;
    }
    .border {
      border: 2px solid #efefef;
    }
    .token-box {
      border-radius: 0.5rem;
      border: 1px solid #fff;
      background: #fff;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25) inset,
        0px 4px 10px 0px rgba(0, 0, 0, 0.1);

      h6 {
        color: #676767 !important;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        font-weight: 500;
        right: 0;
        bottom: -10px;
      }
    }

    .btn {
      &-claim {
        background: #f8c62c;
        color: #fff;
      }
      &-done {
        background: #25cc9a;
        &-2 {
          background: #25cc9a1a;
        }
      }
    }

    .card-shadow {
      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
    }
  }
}

.skeleton {
  background: #808080;
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
</style>
